<template>
  <header class="flex">
    <div class="header-container box-shadow">
      <div class="docendo-logo box-shadow">
        <span class="icon-docendo docendo-logo__icon" id="d-icon"></span>
      </div>
      <div class="nav">
        <div class="nav-left">
          <v-touch @tap="sendClick" class="touch-container mobile-nav">
            <div class="flex">
              <h4>{{ isMonth }}</h4>
              <span class="icon"
                    :class="{'icon-arrow-up5': !showdatepicker, 'icon-arrow-down5': showdatepicker}">
              </span>
            </div>
          </v-touch>
        </div>
        <div class="nav-right">
          <v-touch @tap="$emit('menu')" class="pad-10-right">
            <button class="left-button nav-button">
              <span class="icon-menu"></span>
            </button>
          </v-touch>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
  import filters from '../../../filters/filters' // eslint-disable-line no-unused-vars
  import moment from 'moment'
  export default {
    props: {
      date: {
        default: moment().format('YYYY-MM-DD')
      },
      showdatepicker: {},
      calname: {},
      schoolname: {},
      anyWeekNotes: {
        type: Boolean,
        default: false
      },
      locale: {
        default: window.USER && window.USER.locale ? window.USER.locale : 'en'
      }
    },
    computed: {
      weekNum () {
        return moment(this.date).isoWeek()
      },
      isMonth () {
        return moment(this.date).locale(this.locale).format('MMMM, YYYY')
      }
    },
    methods: {
      sendClick () {
        this.$emit('monthClick')
      }
    }
  }
</script>

<style scoped>
  header {
    flex-direction: column;
  }

  .header-container {
    display: flex;
    justify-content: space-between;
    background: white;
    position: relative;
    z-index: 50;
    width: 100%;
    max-width: 100%;
    height: 55px;
  }

  .nav {
    display: flex;
    justify-content: space-between;
    flex: 1;
    align-items: stretch;
  }

  .touch-container {
    display: flex;
    flex: 1;
    height: 100%;
    padding: 0 20px;
  }

  .nav-left {
    align-items: center;
    display: flex;
    vertical-align: middle;
  }

  .nav-right {
    padding: 0;
    align-items: center;
    display: flex;
    vertical-align: middle;
  }

  .nav-right button {
    height: 40px;
    padding: 2px 15px;
  }

  .nav-button {
    font-size: 16px;
  }

  .right-button {
    margin: 0 5px;
  }

  .touch-container > div {
    align-items: center;
  }

  .touch-container > div > span {
    display: flex;
    align-items: center;
    margin-left: 3px;
  }

  .touch-container > div > span.icon-active {
    transition: all 0.3s;
    transform: rotate(180deg);
  }

  .touch-container > div > h4 {
    font-size: 16px;
  }

  .pad-10-right {
    padding-right: 10px;
  }

  .docendo-logo {
    float: left;
    box-sizing: border-box;
    width: 65px;
    height: 55px;
    background: #468ad7;
    color: #fff;
    cursor: pointer;
    position: relative;
    z-index: 10000;
    text-align: center;
  }

  .docendo-logo__icon {
    font-size: 45px;
    width: 100%;
    height: 100%;
    padding-top: 5px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// Header.vue?934803a0